import { Box, Typography } from '@mui/material';
import { IconSvg } from '../Icon';
import { PdpPhaseDTO } from '@/types/models';
import timeFormat from '@/utils/timeFormat';
interface PhaseItemProps {
  data: PdpPhaseDTO;
  index: number;
}
const PhaseItem = ({
  data,
  index
}: PhaseItemProps) => {
  const {
    title,
    startDate,
    status,
    startDateDesc
  } = data;
  const isFirst = index === 0;
  return <>
      {!isFirst && (status === 'done' ? <IconSvg component='GreenConnection' width='7' height='35' /> : status === 'in_progress' ? <IconSvg component='BlueConnection' width='7' height='35' /> : <IconSvg component='GrayConnection' width='1' height='34' />)}
      <Box sx={{
      width: '100%',
      borderRadius: 'var(--corner_radius_m)',
      border: '1px solid',
      p: 'var(--spacing_m)',
      borderColor: status === 'done' ? 'approve.stroke2' : status === 'in_progress' ? 'primaryBrand.stroke' : status === 'canceled' ? 'background.golden.dark' : 'stroke.stroke2',
      bgcolor: status === 'done' ? 'approve.bg3' : status === 'in_progress' ? 'primaryBrand.bg4' : status === 'canceled' ? 'warning.overlay' : 'background.bg3',
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--spacing_xs)'
    }} data-sentry-element="Box" data-sentry-source-file="PhaseItem.tsx">
        <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 'var(--spacing_xs)'
      }} data-sentry-element="Box" data-sentry-source-file="PhaseItem.tsx">
          {status === 'done' ? <IconSvg component='CircleCheckFiled' width='24' height='24' /> : status === 'canceled' ? <IconSvg component='Info' width='24' height='24' /> : <Typography sx={{
          bgcolor: status === 'in_progress' ? 'primaryBrand.bg5' : status === 'canceled' ? 'background.bg5' : 'background.bg4',
          color: status === 'in_progress' ? 'primaryBrand.text' : 'text.text2',
          borderRadius: '50%',
          border: '1px solid',
          borderColor: status === 'in_progress' ? 'primaryBrand.stroke' : status === 'canceled' ? 'stroke.stroke5' : 'stroke.stroke4',
          width: 24,
          height: 24,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: '3px'
        }} variant='bodyStrong__Wallfund'>
              {index + 1}
            </Typography>}
          <Typography variant='bodyLargeMedium__Wallfund' sx={{
          width: 'calc(100% - 28px)'
        }} data-sentry-element="Typography" data-sentry-source-file="PhaseItem.tsx">
            {title}
          </Typography>
        </Box>
        <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
      }} data-sentry-element="Box" data-sentry-source-file="PhaseItem.tsx">
          <Typography variant='captionStrong__Wallfund' color={status === 'done' ? 'approve.text' : status === 'in_progress' ? 'primaryBrand.text' : status === 'canceled' ? 'text.text3' : 'text.text'} data-sentry-element="Typography" data-sentry-source-file="PhaseItem.tsx">
            {startDateDesc ?? (startDate && timeFormat(new Date(startDate)))}
          </Typography>
          {status !== 'pending' && <Typography variant='captionMedium__Wallfund' sx={{
          borderRadius: 'var(--corner_radius_s)',
          p: 'var(--spacing_xxs)',
          bgcolor: status === 'done' ? 'background.bg' : status === 'in_progress' ? 'primaryBrand.bg' : status === 'canceled' ? 'white' : 'background.bg',
          color: status === 'done' ? 'approve.text' : status === 'in_progress' ? 'onColor.text' : status === 'canceled' ? 'background.golden.dark' : 'text.text'
        }}>
              {status === 'done' ? 'انجام شده' : status === 'in_progress' ? 'در حال انجام' : status === 'canceled' ? 'عدم پرداخت سود به دلیل نکول طرح' : 'مرحله بعد'}
            </Typography>}
        </Box>
      </Box>
    </>;
};
export default PhaseItem;